import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Autocomplete, Checkbox, ListItem, TextField, createFilterOptions } from "@mui/material";
import { useEffect, useState } from "react";

const filter = createFilterOptions<{ name: string; value?: any; inputValue?: string }>();

export interface DataGridAutocompleteProps {
  id: string;
  rows: any[];
  value: any;
  onChange: (event: any, newValue: any) => void;
  label: string;
  hasFocus: boolean;
  freeSolo?: boolean;
  size?: "small" | "medium" | undefined;
  error?: boolean | string | undefined;
  placeholder?: string | undefined;
}

const DataGridAutocomplete = (props: DataGridAutocompleteProps) => {
  const [rows] = useState<any[]>(props.rows);
  const [value, setValue] = useState<any | null>(props.value || null);
  const [size] = useState<"small" | "medium" | undefined>(props.size || "small");
  let inputRef: any;

  useEffect(() => {
    if (props.hasFocus) {
      inputRef?.focus();
    }
  }, [props.hasFocus]);

  return (
    <Autocomplete
      id={props.id}
      options={rows}
      getOptionLabel={(option: any) => {
        if (typeof option === "string") {
          return option;
        } else if (option.inputValue) {
          return option.inputValue;
        }
        return option?.name || "";
      }}
      value={value}
      renderOption={(props: any, option: any, { selected }: { selected: boolean }) => {
        const { key, ...rest } = props;
        return (
          <ListItem key={props.id} {...rest} dense={true}>
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize={size} />}
              checkedIcon={<CheckBoxIcon fontSize={size} />}
              style={{ marginRight: 8 }}
              checked={selected}
              size={size}
            />
            {option.name}
          </ListItem>
        );
      }}
      renderInput={(params: any) => {
        const { key, ...rest } = params;
        return (
          <TextField
            key={key}
            {...rest}
            inputRef={(input) => {
              inputRef = input;
            }}
            size={size}
            variant="standard"
            error={props.error}
            placeholder={props.placeholder}
            slotProps={{
              input: { ...params.InputProps, style: { marginTop: "-1px", paddingTop: "3px", paddingBottom: "3px" } },
              inputLabel: { shrink: false },
            }}
          />
        );
      }}
      onChange={(event: any, newValue: any) => {
        if (props.freeSolo && typeof newValue === "string") {
          setValue({ name: newValue });
          props.onChange(event, newValue);
        } else if (props.freeSolo && newValue && newValue.inputValue) {
          setValue({ name: newValue.inputValue });
          props.onChange(event, newValue.inputValue);
        } else {
          setValue(newValue);
          props.onChange(event, newValue);
        }
      }}
      filterOptions={(options, params) => {
        const { inputValue } = params;
        const filtered = filter(options, params);

        if (props.freeSolo) {
          const isExisting = options.some((option) => option.name === inputValue);
          if (inputValue.trim() !== "" && !isExisting) {
            filtered.push({ name: `Add "${inputValue}"`, inputValue });
          }
        }

        return filtered;
      }}
      sx={{ width: "100%" }}
      freeSolo={props.freeSolo}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      size={size}
      slotProps={{ popper: { style: { width: "fit-content" } } }}
    />
  );
};

export default DataGridAutocomplete;
